// extracted by mini-css-extract-plugin
module.exports = {"CreateAccount":"_2vNhm","MinHeight":"_1tcWd","container768":"_34ZCj","topSpace80":"_1oPip","title":"_2RjqA","congratulations":"_3bgbG","topSpace50":"_30CqM","nextButton":"_3xf2s"};